/**
 * Plain, unadorned range input — no dependency. Per
 * docs/calculator-engine-architecture.md §5: the control is shared engine
 * code; any bespoke annotation chrome (markers, labels) is built by the
 * calculator that uses it, in its own SCSS.
 */
export function Slider({
  id,
  value,
  min,
  max,
  step = 1,
  onChange,
  ariaLabel,
}: {
  id: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (value: number) => void;
  ariaLabel?: string;
}) {
  return (
    <input
      id={id}
      type="range"
      className="hsab-calc__slider"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      aria-label={ariaLabel}
      aria-valuetext={`$${value.toLocaleString('en-US')}`}
    />
  );
}
